// pages/404.js
import React from 'react'
import Link from 'next/link'
import { useRouter } from 'next/router'
import SEO from '../components/seo-head/seo-head'

import { Header } from '../components/header/header'
// Styles
import { base } from '../styles/base/_allBase.styles'
import { Section } from '../components/section/section.component'
import { CenterDiv } from '../styles/base/_base.styles'
import { CustomButton } from '../components/button/button.component'
import { LargeBox } from '../styles/base/_containers.styles'
const {
  Page_Main_Grid_Container,
  StyleP,
  GridContainer_Page_Layout,
  GridItem_HeaderSection,
} = base

const { H1 } = base

export default function PrivacyPolicy() {
  const router = useRouter()
  return (
    <GridContainer_Page_Layout>
      <SEO
        seo={{
          titleFormat: 'complete',
          metaTitle: 'Privacy Policy | Selong Belanak',
          metaDesc: 'How Selong-Belanak.com uses consent-based analytics and protects visitor privacy.',
        }}
        router={router}
        destination={false}
      />
      <GridItem_HeaderSection>
        <header>
          <Header />
        </header>
      </GridItem_HeaderSection>
      <Page_Main_Grid_Container>
        <Section>
          <CenterDiv>
            <LargeBox>
              <CenterDiv>
                <H1>Privacy Policy</H1>
                <StyleP>
                  Selong-Belanak.com uses optional analytics to understand which
                  destination information visitors find useful and which booking,
                  website, telephone, WhatsApp, map and navigation links they choose.
                  Analytics is disabled until you select “Accept analytics”.
                </StyleP>
                <h2>What analytics records</h2>
                <StyleP>
                  With consent, we record page and content identifiers, broad content
                  topics, listing and call-to-action interactions, scroll and active-time
                  milestones, referral and campaign information, device category,
                  browser language, time zone and approximate country or region. We use
                  random first-party journey and session identifiers to understand an
                  anonymous visit across pages. These identifiers are not names and are
                  not used to claim or infer a visitor’s nationality.
                </StyleP>
                <h2>What analytics does not record</h2>
                <StyleP>
                  Our event tracking is designed not to send names, email addresses,
                  telephone numbers, contact-form contents, booking-form contents or raw
                  IP addresses in the first-party event payload. Information that you
                  deliberately submit through a contact form is processed separately so
                  that we can respond to your request.
                </StyleP>
                <h2>Services and purpose</h2>
                <StyleP>
                  A limited reporting copy of consented events is sent to Google
                  Analytics. A fuller event copy may be sent through our own secure
                  collection endpoint for audience, content, SEO and booking-journey
                  analysis. Advertising storage and ad-personalisation signals remain
                  disabled on this website. Analytics is used to improve the guide,
                  identify useful search topics and understand aggregate interest in
                  local businesses and travel planning.
                </StyleP>
                <h2>Your choice</h2>
                <StyleP>
                  You can reject analytics when the consent notice appears. Rejecting
                  clears the anonymous analytics identifiers and related Google
                  Analytics cookies that this site can access. Essential site functions
                  remain available. You can also clear site data in your browser to make
                  a new choice.
                </StyleP>
                <h2>Contact and updates</h2>
                <StyleP>
                  For privacy questions or requests, email info@selong-belanak.com. We
                  may update this notice when the measurement system or its purposes
                  change. Last updated: 30 July 2026.
                </StyleP>
                <Link href="/">
                  <CustomButton>Return to home page</CustomButton>
                </Link>
              </CenterDiv>
            </LargeBox>
          </CenterDiv>
        </Section>
      </Page_Main_Grid_Container>
    </GridContainer_Page_Layout>
  )
}
